export const FLAG_GETTING_ITINERARY_TYPES = 'FLAG_GETTING_ITINERARY_TYPES';
export const GET_ITINERARY_TYPES = 'GET_ITINERARY_TYPES';
export const CLEAR_ITINERARY_TYPES = 'CLEAR_ITINERARY_TYPES';
